<template>
  <XModal ref="modal" v-bind="$attrs" @afterClose="afterClose" :title="title" :ok="scanned" :forceRender="true" :zIndex="9999" :footer="false">
    <p class="fs24 mt20 color-primary center">
      <slot>
        * 请使用扫码枪进行扫码
      </slot>
    </p>
    <AInput class="o0 h0" ref="input" type="password" v-model="keyword" @pressEnter="scanned" @blur="focus"></AInput>
    <!-- <p class="mt30 color-danger center">* 如果没有自动关闭，请点击下方确认按钮</p> -->
  </XModal>
</template>
<script>
export default {
  props: {
    title: {
      default: "扫码窗口"
    },
  },
  data() {
    return {
      keyword: null,
    };
  },
  computed:{
  },
  mounted(){
  },
  methods:{
    open(){
      this.keyword = null
      setTimeout(() => {
        this.focus()
      })
      this.$refs.modal.open()
    },
    scanned(){
      this.$emit('scanned', this.keyword)
      setTimeout(() => {
        this.$refs.modal.cancel()
      }, 50)
    },
    focus(){
      this.$refs.input.focus()
    },
    afterClose(){
      this.keyword = null
    }
  }
};
</script>
<style lang="less" scoped>
</style>
